import { createSlice } from "@reduxjs/toolkit";

interface InstitutionalInitialStateModel {
  initialStoreInfoes: any;
  doneStesps: number[];
  email: string | null;
  tempFormData: any | null;  // ✅ Yeni eklenen state
}

const institutionalInitialState: InstitutionalInitialStateModel = {
  initialStoreInfoes: null,
  email: null,
  doneStesps: [],
  tempFormData: null,  // ✅ Başlangıç değeri
};

const institutionaleSlice = createSlice({
  name: "institutionaleSlice",
  initialState: institutionalInitialState,
  reducers: {
    handleSetinstitutionalStoreInfoes: (state, action) => {
      state.initialStoreInfoes = action.payload.data;
    },
    handleSetDoneSteps: (state, action) => {
      state.doneStesps = action.payload.data;
    },
    handleSetEmail: (state, action) => {
      state.email = action.payload.email;
    },
    handleSetTempFormData: (state, action) => {   // ✅ Yeni reducer
      state.tempFormData = action.payload.data;
    },
  },
});

export const {
  handleSetinstitutionalStoreInfoes,
  handleSetDoneSteps,
  handleSetEmail,
  handleSetTempFormData,  // ✅ Export edilen yeni action
} = institutionaleSlice.actions;

export default institutionaleSlice;
